import type { Metadata } from "next";
import AdminPaymentMethod from "@/Component/Admin/AdminPaymentMethod";

export const metadata: Metadata = {
    title: "Payment Method | Connector Club",
    description: "Manage payment methods and country assignments",
};

const PaymentMethodPage = () => {
    return <AdminPaymentMethod />;
};

export default PaymentMethodPage;
